import * as i0 from '@angular/core';
import { inject, EventEmitter, ElementRef, Component, ChangeDetectionStrategy, Input, Output, ViewChild, NgModule } from '@angular/core';
import { tuiInjectElement } from '@taiga-ui/cdk/utils/dom';
import { TUI_COMMON_ICONS } from '@taiga-ui/core/tokens';
import { tuiStringHashToHsl } from '@taiga-ui/core/utils/format';
import { tuiSizeBigger } from '@taiga-ui/core/utils/miscellaneous';
import { tuiCreateToken, tuiProvideOptions } from '@taiga-ui/cdk/utils/miscellaneous';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i3 from '@taiga-ui/core/components/icon';
import { TuiIcon } from '@taiga-ui/core/components/icon';
import * as i4 from '@taiga-ui/core/components/loader';
import { TuiLoader } from '@taiga-ui/core/components/loader';
import * as i5 from '@taiga-ui/polymorpheus';
import { PolymorpheusOutlet, PolymorpheusTemplate } from '@taiga-ui/polymorpheus';

/**
 * @deprecated: drop in v5.0 use {@link TuiChip}
 * https://taiga-ui.dev/components/chip
 */
const _c0 = ["input"];
const _c1 = () => ({
  standalone: true
});
function TuiTagComponent_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const text_r1 = ctx.polymorpheusOutlet;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", text_r1, " ");
  }
}
function TuiTagComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, TuiTagComponent_div_1_ng_container_1_Template, 2, 1, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("polymorpheusOutlet", ctx_r1.leftContent);
  }
}
function TuiTagComponent_tui_loader_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-loader", 9);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("inheritColor", true)("size", ctx_r1.loaderSize);
  }
}
function TuiTagComponent_tui_icon_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tui-icon", 10);
    i0.ɵɵlistener("click", function TuiTagComponent_tui_icon_4_Template_tui_icon_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.remove($event));
    })("mousedown.stop.prevent.zoneless", function TuiTagComponent_tui_icon_4_Template_tui_icon_mousedown_stop_prevent_zoneless_0_listener() {
      i0.ɵɵrestoreView(_r3);
      return i0.ɵɵresetView(0);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r1.icons.close);
  }
}
function TuiTagComponent_input_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 11, 0);
    i0.ɵɵlistener("blur", function TuiTagComponent_input_5_Template_input_blur_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlur());
    })("keydown", function TuiTagComponent_input_5_Template_input_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onKeyDown($event));
    })("ngModelChange", function TuiTagComponent_input_5_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onInput($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r1.editedText)("ngModelOptions", i0.ɵɵpureFunction0(3, _c1));
    i0.ɵɵattribute("maxLength", ctx_r1.maxLength);
  }
}
const TUI_TAG_DEFAULT_OPTIONS = {
  size: 'm',
  status: 'default',
  autoColor: false
};
/**
 * @deprecated: drop in v5.0 use {@link TuiChip}
 * https://taiga-ui.dev/components/chip
 */
const TUI_TAG_OPTIONS = tuiCreateToken(TUI_TAG_DEFAULT_OPTIONS);
/**
 * @deprecated: drop in v5.0 use {@link TuiChip}
 * https://taiga-ui.dev/components/chip
 */
function tuiTagOptionsProvider(options) {
  return tuiProvideOptions(TUI_TAG_OPTIONS, options, TUI_TAG_DEFAULT_OPTIONS);
}

/**
 * @deprecated: drop in v5.0 use {@link TuiChip}
 * https://taiga-ui.dev/components/chip
 */
let TuiTagComponent = /*#__PURE__*/(() => {
  class TuiTagComponent {
    constructor() {
      this.el = tuiInjectElement();
      this.options = inject(TUI_TAG_OPTIONS);
      this.editing = false;
      this.icons = inject(TUI_COMMON_ICONS);
      this.editedText = null;
      this.value = '';
      this.editable = false;
      this.separator = ',';
      this.maxLength = null;
      this.size = this.options.size;
      this.showLoader = false;
      this.status = this.options.status;
      this.hoverable = false;
      this.removable = false;
      this.disabled = false;
      this.autoColor = this.options.autoColor;
      this.edited = new EventEmitter();
    }
    set input(input) {
      if (input) {
        input.nativeElement.focus();
      }
    }
    get backgroundColor() {
      return this.autoColor ? tuiStringHashToHsl(this.value) : null;
    }
    get canRemove() {
      return this.removable && !this.disabled && !this.showLoader;
    }
    get displayText() {
      return this.editedText ?? this.value;
    }
    get loaderSize() {
      return tuiSizeBigger(this.size) ? 's' : 'xs';
    }
    edit(event) {
      if (!this.canEdit) {
        return;
      }
      event.preventDefault();
      this.editing = true;
      this.editedText = this.value;
    }
    remove(event) {
      if (!this.canRemove) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      this.edited.emit('');
    }
    onInput(value) {
      const newTags = value.split(this.separator);
      if (newTags.length > 1) {
        this.save(String(newTags));
        return;
      }
      this.editedText = value;
    }
    onKeyDown(event) {
      event.stopPropagation();
      switch (event.key.toLowerCase()) {
        case 'enter':
          event.preventDefault();
          this.save(this.editedText || '');
          break;
        case 'esc':
        case 'escape':
          event.preventDefault();
          this.stopEditing();
          this.el.focus();
          break;
        default:
          break;
      }
    }
    onBlur() {
      if (this.editedText !== null) {
        this.save(this.editedText);
      }
    }
    get canEdit() {
      return this.editable && !this.disabled && !this.showLoader;
    }
    stopEditing() {
      this.editing = false;
      this.editedText = null;
    }
    save(value) {
      this.stopEditing();
      this.edited.emit(value.trim());
    }
    static {
      this.ɵfac = function TuiTagComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiTagComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiTagComponent,
        selectors: [["tui-tag"], ["a", "tuiTag", ""], ["button", "tuiTag", ""]],
        viewQuery: function TuiTagComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
          }
        },
        hostVars: 10,
        hostBindings: function TuiTagComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown.delete", function TuiTagComponent_keydown_delete_HostBindingHandler($event) {
              return ctx.remove($event);
            })("keydown.backspace", function TuiTagComponent_keydown_backspace_HostBindingHandler($event) {
              return ctx.remove($event);
            })("keydown.enter", function TuiTagComponent_keydown_enter_HostBindingHandler($event) {
              return ctx.edit($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("data-size", ctx.size)("data-status", ctx.status);
            i0.ɵɵclassProp("_editing", ctx.editing)("_hoverable", ctx.hoverable)("_autocolor", ctx.autoColor)("_disabled", ctx.disabled);
          }
        },
        inputs: {
          value: "value",
          editable: "editable",
          separator: "separator",
          maxLength: "maxLength",
          size: "size",
          showLoader: "showLoader",
          status: "status",
          hoverable: "hoverable",
          removable: "removable",
          disabled: "disabled",
          autoColor: "autoColor",
          leftContent: "leftContent"
        },
        outputs: {
          edited: "edited"
        },
        standalone: false,
        decls: 6,
        vars: 7,
        consts: [["input", ""], [1, "t-tag", 3, "dblclick"], ["class", "t-content", 4, "ngIf"], ["automation-id", "tui-tag__text", 1, "t-text", 3, "textContent"], ["class", "t-content", 3, "inheritColor", "size", 4, "ngIf"], ["automation-id", "tui-tag__remove", "class", "t-icon", 3, "icon", "click", "mousedown.stop.prevent.zoneless", 4, "ngIf"], ["automation-id", "tui-tag__edit", "type", "text", "class", "t-edit", 3, "ngModel", "ngModelOptions", "blur", "keydown", "ngModelChange", 4, "ngIf"], [1, "t-content"], [4, "polymorpheusOutlet"], [1, "t-content", 3, "inheritColor", "size"], ["automation-id", "tui-tag__remove", 1, "t-icon", 3, "click", "mousedown.stop.prevent.zoneless", "icon"], ["automation-id", "tui-tag__edit", "type", "text", 1, "t-edit", 3, "blur", "keydown", "ngModelChange", "ngModel", "ngModelOptions"]],
        template: function TuiTagComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵlistener("dblclick", function TuiTagComponent_Template_div_dblclick_0_listener($event) {
              return ctx.edit($event);
            });
            i0.ɵɵtemplate(1, TuiTagComponent_div_1_Template, 2, 1, "div", 2);
            i0.ɵɵelement(2, "span", 3);
            i0.ɵɵtemplate(3, TuiTagComponent_tui_loader_3_Template, 1, 2, "tui-loader", 4)(4, TuiTagComponent_tui_icon_4_Template, 1, 1, "tui-icon", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, TuiTagComponent_input_5_Template, 2, 4, "input", 6);
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("background-color", ctx.backgroundColor);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.leftContent);
            i0.ɵɵadvance();
            i0.ɵɵproperty("textContent", ctx.displayText);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showLoader);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.canRemove);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.editing);
          }
        },
        dependencies: [i1.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, i3.TuiIcon, i4.TuiLoader, i5.PolymorpheusOutlet],
        styles: ["[_nghost-%COMP%]{transition-property:background;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;position:relative;display:inline-block;font:var(--tui-font-text-s);line-height:1.25rem;max-inline-size:100%;cursor:default;outline:none;text-decoration:none;padding:0;border:0}[_nghost-%COMP%]:after{transition-property:background;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;position:absolute;top:0;left:0;inline-size:100%;block-size:100%;content:\"\";box-sizing:border-box;border-radius:inherit;pointer-events:none}._hoverable[_nghost-%COMP%]:hover[data-status=custom]:after, ._hoverable[_nghost-%COMP%]:active[data-status=custom]:after{background-color:var(--tui-background-neutral-1)}[_nghost-%COMP%]:focus:after{border:2px solid var(--tui-border-focus)}[data-size=s][_nghost-%COMP%]{font:var(--tui-font-text-xs);line-height:1.25rem;border-radius:var(--tui-radius-xs)}[data-size=m][_nghost-%COMP%]{border-radius:var(--tui-radius-xs)}[data-size=l][_nghost-%COMP%]{border-radius:var(--tui-radius-s)}[data-status=primary][_nghost-%COMP%]{background-color:var(--tui-background-accent-1);color:var(--tui-text-primary-on-accent-1)}[data-status=primary]._hoverable[_nghost-%COMP%]:hover{background-color:var(--tui-background-accent-1-hover)}[data-status=primary]._hoverable[_nghost-%COMP%]:active{background-color:var(--tui-background-accent-1-pressed)}[data-status=error][_nghost-%COMP%]{background-color:var(--tui-status-negative-pale);color:var(--tui-text-primary)}[data-status=error]._hoverable[_nghost-%COMP%]:hover, [data-status=error]._hoverable[_nghost-%COMP%]:active{background-color:var(--tui-status-negative-pale-hover)}[tuiTheme=\"dark\"]   [data-status=error][_nghost-%COMP%]{background-color:var(--tui-status-negative-pale);color:var(--tui-text-primary)}[tuiTheme=\"dark\"]   [data-status=error]._hoverable[_nghost-%COMP%]:hover, [tuiTheme=\"dark\"]   [data-status=error]._hoverable[_nghost-%COMP%]:active{background-color:var(--tui-status-negative-pale-hover)}[data-status=success][_nghost-%COMP%]{background-color:var(--tui-status-positive-pale);color:var(--tui-text-primary)}[data-status=success]._hoverable[_nghost-%COMP%]:hover, [data-status=success]._hoverable[_nghost-%COMP%]:active{background-color:var(--tui-status-positive-pale-hover)}[tuiTheme=\"dark\"]   [data-status=success][_nghost-%COMP%]{background-color:var(--tui-status-positive-pale);color:var(--tui-text-primary)}[tuiTheme=\"dark\"]   [data-status=success]._hoverable[_nghost-%COMP%]:hover, [tuiTheme=\"dark\"]   [data-status=success]._hoverable[_nghost-%COMP%]:active{background-color:var(--tui-status-positive-pale-hover)}[data-status=warning][_nghost-%COMP%]{background-color:var(--tui-status-warning-pale);color:var(--tui-text-primary)}[data-status=warning]._hoverable[_nghost-%COMP%]:hover, [data-status=warning]._hoverable[_nghost-%COMP%]:active{background-color:var(--tui-status-warning-pale-hover)}[tuiTheme=\"dark\"]   [data-status=warning][_nghost-%COMP%]{background-color:var(--tui-status-warning-pale);color:var(--tui-text-primary)}[tuiTheme=\"dark\"]   [data-status=warning]._hoverable[_nghost-%COMP%]:hover, [tuiTheme=\"dark\"]   [data-status=warning]._hoverable[_nghost-%COMP%]:active{background-color:var(--tui-status-warning-pale-hover)}[data-status=default][_nghost-%COMP%]{color:#fff;background-color:var(--tui-text-tertiary)}[data-status=default]._hoverable[_nghost-%COMP%]:hover{background-color:var(--tui-background-accent-opposite-pressed)}[data-status=default]._hoverable[_nghost-%COMP%]:active{background-color:var(--tui-background-accent-opposite-hover)}[tuiTheme=\"dark\"]   [data-status=default][_nghost-%COMP%]{color:var(--tui-text-primary);background-color:var(--tui-background-neutral-1)}[tuiTheme=\"dark\"]   [data-status=default]._hoverable[_nghost-%COMP%]:hover{background-color:var(--tui-background-neutral-1-hover)}[tuiTheme=\"dark\"]   [data-status=default]._hoverable[_nghost-%COMP%]:active{background-color:var(--tui-background-neutral-1-pressed)}[tuiTheme=\"dark\"]   [data-status=default][_nghost-%COMP%]:focus:after{border:2px solid var(--tui-background-base)}._editing[_nghost-%COMP%]{background:transparent!important}._disabled[_nghost-%COMP%], [_nghost-%COMP%]   *:disabled[_nghost-%COMP%], *:disabled   [_nghost-%COMP%]{pointer-events:none;opacity:var(--tui-disabled-opacity)}._hoverable[_nghost-%COMP%]{cursor:pointer}._autocolor[_nghost-%COMP%]{color:#000c}.t-text[_ngcontent-%COMP%]{white-space:pre;overflow:hidden;text-overflow:ellipsis;padding-right:.02em}.t-tag[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;position:relative;display:flex;inline-size:auto;align-items:center;font:inherit;border-radius:inherit}[data-size=s][_nghost-%COMP%]   .t-tag[_ngcontent-%COMP%]{block-size:1.25rem;padding:0 .375rem}[data-size=m][_nghost-%COMP%]   .t-tag[_ngcontent-%COMP%]{block-size:var(--tui-height-xs);padding:0 .5rem}[data-size=l][_nghost-%COMP%]   .t-tag[_ngcontent-%COMP%]{block-size:var(--tui-height-s);padding:0 .75rem}._editing[_nghost-%COMP%]   .t-tag[_ngcontent-%COMP%]{visibility:hidden}.t-edit[_ngcontent-%COMP%]{padding:0;margin:0;border-width:0;border-radius:inherit;background:none;font-size:inherit;line-height:inherit;font-weight:inherit;color:inherit;caret-color:currentColor;outline:none;-webkit-appearance:none;appearance:none;word-break:keep-all;-webkit-text-fill-color:currentColor;position:absolute;top:0;left:0;font:inherit;color:var(--tui-text-primary);inline-size:100%;block-size:100%;box-sizing:border-box;padding:0 .5rem}.t-edit[_ngcontent-%COMP%]:-webkit-autofill, .t-edit[_ngcontent-%COMP%]:-webkit-autofill:hover, .t-edit[_ngcontent-%COMP%]:-webkit-autofill:focus{-webkit-text-fill-color:var(--tui-text-primary)!important;border-color:var(--tui-service-autofill-background);box-shadow:0 0 0 100rem var(--tui-service-autofill-background) inset!important}[data-size=s][_nghost-%COMP%]   .t-edit[_ngcontent-%COMP%]{padding:0 .375rem}[data-size=m][_nghost-%COMP%]   .t-edit[_ngcontent-%COMP%]{padding:0 .5rem}[data-size=l][_nghost-%COMP%]   .t-edit[_ngcontent-%COMP%]{padding:0 .75rem}.t-icon[_ngcontent-%COMP%]{font-size:1rem;block-size:100%;cursor:pointer;pointer-events:all;opacity:var(--tui-disabled-opacity);margin-inline-start:.25rem;margin-inline-end:-.25rem}.t-icon[_ngcontent-%COMP%]:hover{opacity:1}[data-size=s][_nghost-%COMP%]   .t-icon[_ngcontent-%COMP%]{margin-inline-start:0;block-size:.75rem}.t-content[_ngcontent-%COMP%]{inline-size:1rem;block-size:1rem;margin-inline-end:.25rem}"],
        changeDetection: 0
      });
    }
  }
  return TuiTagComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @deprecated: drop in v5.0 use {@link TuiChip}
 * https://taiga-ui.dev/components/chip
 */
let TuiTagModule = /*#__PURE__*/(() => {
  class TuiTagModule {
    static {
      this.ɵfac = function TuiTagModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiTagModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TuiTagModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, TuiIcon, TuiLoader]
      });
    }
  }
  return TuiTagModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_TAG_DEFAULT_OPTIONS, TUI_TAG_OPTIONS, TuiTagComponent, TuiTagModule, tuiTagOptionsProvider };
